import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DatePicker, InputLabel } from '@hopskipdrive/react-components';
import { parseISO } from 'date-fns';
import * as Yup from 'yup';

import { DateFilterContainer } from './styles';

export const DateFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [error, setError] = useState<string>('');
  const fromDateString = searchParams.get('fromDate');
  const dateFromLocation = fromDateString ? parseISO(fromDateString) : new Date();

  useEffect(() => {
    !fromDateString &&
      setSearchParams(
        (prevParams) => {
          return new URLSearchParams({
            ...Object.fromEntries(prevParams.entries()),
            fromDate: new Date().toISOString(),
          });
        },
        { replace: true }
      );
  }, []);

  const handleDateChange = async (date: Date) => {
    setSearchParams((prevParams) => {
      return new URLSearchParams({
        ...Object.fromEntries(prevParams.entries()),
        fromDate: date.toISOString(),
      });
    });
  };

  const handleKeyboardDateFilter = async (e) => {
    if (e.key === 'Enter') {
      const inputValue = e.target.value.replace(/[^0-9\/]/g, '');

      const isFormValid = await formSchema.isValid({ date: inputValue });

      if (isFormValid) {
        handleDateChange(new Date(inputValue));
      } else {
        formSchema.validate({ date: inputValue }, { abortEarly: false }).catch((err) => {
          setError(err.inner[0].errors[0]);
        });
      }
    }
  };

  return (
    <DateFilterContainer>
      <InputLabel htmlFor="date-picker">Date</InputLabel>
      <DatePicker
        onChange={(date) => {
          if (!date || (date instanceof Date && date.getTime())) {
            setError('');
          }
        }}
        value={dateFromLocation}
        onAccept={(date) => {
          if (!!date && date instanceof Date && date.getTime()) {
            handleDateChange(date);
          }
        }}
        slotProps={{
          textField: {
            id: 'date-picker',
            error: !!error,
            helperText: error,
            onKeyDown: handleKeyboardDateFilter,
            inputProps: {
              'data-testid': 'rides-date-picker',
            },
          },
        }}
      />
    </DateFilterContainer>
  );
};

const formSchema = Yup.object().shape({
  date: Yup.string()
    .required('Please enter an start date.')
    .matches(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19\d{2}|20[0-2]\d)$/, 'Please enter a valid date'),
});
